module.exports = __webpack_public_path__ + "static/hero3-7aefedbfd971d8c1379e9a813c0e8a35.webp";